import { Snackbar } from '@material-ui/core';
import { LoanControllerApi } from 'client';
import { InfoBox } from 'components/box/InfoBox';
import { ControlLayout } from 'components/ControlLayout';
import { MultiFormCardHeader } from 'components/MultiFormCardHeader';
import { LoadingModal } from 'components/response/LoadingModal';
import { DATA_LAYERS, DATA_LAYER_RESPONSE_KEY } from 'constants/DataLayers';
import {
	RESPONSE_PATH,
	RESPONSE_VIEW_AUTOATENCION_EXITO,
	RESPONSE_VIEW_DOCUMENT_UPDATE_OK,
	RESPONSE_VIEW_ERROR,
} from 'constants/ResponseType';
import { LoandingContext } from 'context/LoandingContext';
import { SnackbarContext } from 'context/SnackbarContext';
import { useDocument } from 'hooks/useDocument';
import { useLogin } from 'hooks/useLogin';
import React, { useContext, useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { useHistory, useParams } from 'react-router-dom';
import checkIsMobile from 'utils/CheckIsMobile';
import { getTokenFromStorage } from 'utils/GetTokenFromStorage';
import { OptionModal } from 'components/modals/OptionsModal';
import { ButtonModal } from 'models/ButtonModal';
import { CreateDocumentView } from 'components/upload-document/CreateDocumentView';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

interface Params {
	crmId: string;
}

export const DocumentUploadContainer = () => {
	const params = useParams<Params>();
	const history = useHistory();
	const [showLoadingModal, setShowLoadingModal] = useState(false);
	const [login] = useLogin();
	const [complete, setCompleted] = useState(false);
	const [isLoadingComplete, setIsLoadingComplete] = useState(false);

	const [documentsView, setDocumentsView] = useState<JSX.Element>();

	const [isOpen, setIsOpen] = useState(false);

	const { setLoading } = useContext(LoandingContext);

	const {
		documents,
		isInstantUser,
		getDocuments,
		notifyIncompleteDocuments,
		documentTypes,
		jobType,
	} = useDocument(setShowLoadingModal);

	useEffect(
		() => {
			setLoading(true);
			login(
				() => {
					setShowLoadingModal(true);
					getDocuments(params.crmId).finally(() => {
						setIsLoadingComplete(true);
					});
				},
				() => {
					history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`);
				}
			);
		},
		//eslint-disable-next-line
		[]
	);

	useEffect(
		() => {
			if (isLoadingComplete) {
				let documentViewProps = {
					documents,
					setCompleted,
					documentTypes,
					crmId: params.crmId,
					setShowLoadingModal,
					modal: <></>,
				};
				let content = <></>;

				if (documentTypes.length === 0) {
					setLoading(true);

					const controller = new LoanControllerApi();
					controller
						.notificationLoanDocumentUsingGET('WITH_DOCUMENT', getTokenFromStorage(), params.crmId)
						.then(() => {
							setLoading(false);

							history.push(
								`${RESPONSE_PATH}/${RESPONSE_VIEW_AUTOATENCION_EXITO}/sin-documentos-requeridos`
							);
						})
						.catch(() => {
							setLoading(false);

							history.push(
								`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/${DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_DOCUMENTOS_ERROR_SERVICIO}`
							);
						});
					return;
				}

				if (isInstantUser) {
					content = (
						<div
							style={{
								paddingBottom: 40,
							}}
						>
							<p>Para completar tu solicitud debes adjuntar la siguiente documentación:</p>

							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',
									alignItems: 'center',
									marginTop: 24,
									backgroundColor: 'rgba(78, 178, 235, 0.15)',
									borderRadius: 8,
									padding: 24,
								}}
							>
								<CheckCircleOutlineIcon color="primary" width={40} fontSize="large" />
								<p
									className="body-bold primary-color"
									style={{
										marginTop: 8,
										textAlign: 'center',
									}}
								>
									Tu crédito está pre-aprobado, pídelo adjuntando sólo tu comprobante de domicilio
								</p>
							</div>
							<p
								style={{
									fontWeight: 'bold',
									textAlign: 'center',
									marginTop: 32,
									marginBottom: 16,
								}}
							>
								¿Tienes esta documentación a mano?"
							</p>
							<div
								style={{
									backgroundColor: 'rgba(78, 178, 235, 0.15)',
									position: 'absolute',
									left: 0,
									width: '100%',
									textAlign: 'center',
									boxSizing: 'border-box',
									padding: '8px 16px',
								}}
							>
								Recuerda que tendrás{' '}
								<span className="body-bold">
									{' '}
									1 hora para subir toda la documentación y obtener tu descuento.
								</span>
							</div>
						</div>
					);
				} else {
					if (jobType === 'INDEPENDENT') {
						content = (
							<div
								style={{
									paddingBottom: 40,
								}}
							>
								<p>Para completar tu solicitud debes adjuntar la siguiente documentación:</p>
								<ul style={{ marginLeft: 24, marginTop: 16 }}>
									<li>
										Carpeta Tributaria{' '}
										<span className="primary-color">(necesitarás tu clave única de SII)</span>
									</li>
									<li>Comprobante de domicilio (Ej: cuenta luz, agua, internet)</li>
								</ul>

								<p
									style={{
										fontWeight: 'bold',
										textAlign: 'center',
										marginTop: 32,
										marginBottom: 16,
									}}
								>
									¿Tienes esta documentación a mano?
								</p>

								<div
									style={{
										backgroundColor: 'rgba(78, 178, 235, 0.15)',
										position: 'absolute',
										left: 0,
										width: '100%',
										textAlign: 'center',
										boxSizing: 'border-box',
										padding: '8px 16px',
									}}
								>
									Recuerda que tendrás{' '}
									<span className="body-bold">
										{' '}
										1 hora para subir toda la documentación y obtener tu descuento.
									</span>
								</div>
							</div>
						);
					} else {
						content = (
							<div
								style={{
									paddingBottom: 40,
								}}
							>
								<p>Para completar tu solicitud debes adjuntar la siguiente documentación:</p>

								<ul style={{ marginLeft: 24, marginTop: 16 }}>
									<li>3 últimas liquidaciónes de sueldo</li>
									<li>Comprobante de domicilio (Ej: cuenta luz, agua, internet) </li>
									<li>12 cotizaciones de afp con Rut del empleador</li>
								</ul>

								<p
									style={{
										fontWeight: 'bold',
										textAlign: 'center',
										marginTop: 32,
										marginBottom: 16,
									}}
								>
									¿Tienes esta documentación a mano?"
								</p>
								<div
									style={{
										backgroundColor: 'rgba(78, 178, 235, 0.15)',
										position: 'absolute',
										left: 0,
										width: '100%',
										textAlign: 'center',
										boxSizing: 'border-box',
										padding: '8px 16px',
									}}
								>
									Recuerda que tendrás{' '}
									<span className="body-bold">
										{' '}
										1 hora para subir toda la documentación y obtener tu descuento.
									</span>
								</div>
							</div>
						);
					}
				}
				documentViewProps.modal = (
					<OptionModal
						dataLayerKey={DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_MODAL_DOCUMENTOS}
						title="Antes de continuar"
						content={content}
						showCloseButton={true}
						buttons={[
							{
								label: '¡Si, la tengo!',
								variant: 'contained',
								color: 'primary',
								onCloseFuntion: true,
								onClick: () => {
									TagManager.dataLayer({
										dataLayer: DATA_LAYERS.get(
											DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_ADJUNTAR_DOCUMENTOS
										),
									});
								},
							} as ButtonModal,
							{
								label: 'Necesito reunirla',
								variant: 'text',
								color: 'primary',
								onClick: () => {
									notifyIncompleteDocuments(params.crmId);
								},
							} as ButtonModal,
						]}
					/>
				);
				setDocumentsView(<CreateDocumentView {...documentViewProps} />);
			}
		},
		//eslint-disable-next-line
		[isLoadingComplete]
	);

	const classContainer = checkIsMobile()
		? 'portabilidad-container'
		: 'portabilidad-container card-box';

	return (
		<div className={classContainer}>
			<SnackbarContext.Provider
				value={{
					setOpen: setIsOpen,
				}}
			>
				<LoadingModal showLoadingModal={showLoadingModal} />
				<MultiFormCardHeader
					title="Adjunta tus documentos"
					body={<p>Según sea tu caso sube la documentación solicitada en cada sección.</p>}
				/>
				{documentsView}
				<InfoBox
					title="¡Importante!"
					content={
						<>
							<p>
								Para continuar debes <b>adjuntar al menos 1 archivo en cada sección,</b> si te falta
								algún documento, puedes subirlo más tarde{' '}
								<span
									onClick={() => {
										notifyIncompleteDocuments(params.crmId);
									}}
									className="secondary-color"
									style={{ fontWeight: 'bold', cursor: 'pointer' }}
								>
									haciendo clic aquí.
								</span>
							</p>
						</>
					}
					margin="56px 0 0 0"
				/>
				<ControlLayout
					inputError={!complete}
					disableBackButton={true}
					buttonBackName=""
					buttonNextName="Continuar"
					handleBackClick={() => null}
					handleNextClick={() => {
						const controller = new LoanControllerApi();
						setShowLoadingModal(true);
						controller
							.notificationDocumentLoanCrmIdentifierUsingPOST(
								getTokenFromStorage(),
								Number(params.crmId)
							)
							.then(() => {
								setShowLoadingModal(false);
								history.push(
									`${RESPONSE_PATH}/${RESPONSE_VIEW_DOCUMENT_UPDATE_OK}/${DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_DOCUMENTOS_ENVIADOS}`
								);
							})
							.catch(() => {
								history.push(
									`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/${DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_DOCUMENTOS_ERROR_SERVICIO}`
								);
							});
					}}
				/>
			</SnackbarContext.Provider>
			<Snackbar
				autoHideDuration={4000}
				open={isOpen}
				onClose={() => {
					setIsOpen(false);
				}}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center',
				}}
			>
				<div
					className="body gris-6"
					style={{
						backgroundColor: '#f44336',
						color: '#fff',
						padding: '8px 16px',
						borderRadius: '8px',
					}}
				>
					Archivo supera el tamaño máximo permitido
				</div>
			</Snackbar>
		</div>
	);
};
